export { requestBuilder } from "@smithy/core/protocols";
